import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

const USER_INVITATION_QUERY = gql`
  query UserInvitation($token: String!) {
    userInvitation(token: $token) {
      id
      email
      role
      status
      expiresAt
      createdAt
    }
  }
`;

export function useUserInvitation(token: string) {
  const { data, loading, error } = useQuery(USER_INVITATION_QUERY, {
    variables: { token },
    fetchPolicy: 'network-only',
    onError: (error: any) => {
      const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao carregar convite';
      toast.error(message);
    },
  } as any);

  return {
    invitation: (data as any)?.userInvitation || null,
    loading,
    error,
  };
}
